/** 무통장입금 화면들이 함께 쓰는 표시 형식. */

export const money = (value: number) => `${value.toLocaleString("ko-KR")}원`;

export const date = (value?: string) =>
  value
    ? new Intl.DateTimeFormat("ko-KR", { dateStyle: "medium" }).format(
        new Date(value),
      )
    : "—";

/** 입금 시각. 오늘 것은 시:분만, 이전 것은 날짜를 앞에 붙인다. */
export const dateTime = (value?: string) => {
  if (!value) return "—";
  const at = new Date(value);
  const time = new Intl.DateTimeFormat("ko-KR", {
    hour: "2-digit",
    minute: "2-digit",
  }).format(at);
  if (at.toDateString() === new Date().toDateString()) return time;
  return `${new Intl.DateTimeFormat("ko-KR", { month: "2-digit", day: "2-digit" }).format(at)} ${time}`;
};

export const isoDate = (at: Date) => {
  const pad = (n: number) => `${n}`.padStart(2, "0");
  return `${at.getFullYear()}-${pad(at.getMonth() + 1)}-${pad(at.getDate())}`;
};

/** 며칠 지났는지. 입금을 기다리는 주문이 얼마나 묵었는지 보는 용도다. */
export const elapsedDays = (value?: string) => {
  if (!value) return 0;
  const diff = Date.now() - new Date(value).getTime();
  return Math.max(0, Math.floor(diff / 86_400_000));
};
